import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {useFormik} from "formik";
import * as yup from 'yup';
import AppInput from "../Shared/AppInput";
import MyOpinionLogo from '../../assets/images/MyOpinion_Logo_Head.png';
import useAlert from "../../hooks/useAlert";
import httpService from "../../services/http.service";
import { handleFormError } from "../../services/errorHandler.service";
import AppAlert from "../Shared/AppAlert";
import {extractResponseValidationErrors} from "../../utils/index";

/** Choix du nouveau mot de passe avec le lien reçu par e-mail (/reset-password?token=...&email=...). */
const ResetPassword = ({history, location}) => {
	const { t } = useTranslation();
	const query = new URLSearchParams(location.search);
	const token = query.get('token') || '';
	const email = query.get('email') || '';

	const [submitting, setSubmitting] = useState(false);
	const [alert, setAlert, onClose] = useAlert();

	const onSubmit = async (values) => {
		setSubmitting(true);
		setAlert(null);

		try {
			await httpService.post('/auth/reset-password', {...values, token, email});

			setAlert({type: 'success', message: t('Mot de passe modifié. Vous pouvez maintenant vous connecter.')});
			setTimeout(() => history.replace('/login'), 2500);
		} catch (error) {
			handleFormError(error, setAlert, {
				customMessages: {
					422: extractResponseValidationErrors(error.response?.data)?.[0] ||
					     t("Ce lien est invalide ou a expiré. Faites une nouvelle demande."),
					429: t("Trop de tentatives. Réessayez dans quelques instants."),
					500: t("Une erreur s'est produite. Veuillez réessayer plus tard.")
				}
			});
		} finally {
			setSubmitting(false);
		}
	};

	const formik = useFormik({
		initialValues: {password: '', password_confirmation: ''},
		validationSchema: yup.object().shape({
			password: yup.string().ensure().min(8, t('Minimum 8 caractères')).required(t('Champ obligatoire')),
			password_confirmation: yup.string().ensure()
				.oneOf([yup.ref('password')], t('Le mot de passe ne correspond pas'))
				.required(t('Champ obligatoire')),
		}),
		onSubmit
	});

	const linkIsIncomplete = !token || !email;

	return (
		<>
			<div className="pattern">
				<span className="red"/>
				<span className="indigo"/>
				<span className="blue"/>
				<span className="green"/>
				<span className="orange"/>
			</div>
			<div className="auth-main particles_js">
				<div className="auth_div vivify popIn">
					<div className="auth_brand">
						<Link className="navbar-brand" to="/">
							<img src={MyOpinionLogo} width={process.env.REACT_APP_AUTH_LOGO_HEIGHT} height={process.env.REACT_APP_AUTH_LOGO_WIDTH} className="d-inline-block align-top mr-2" alt={process.env.REACT_APP_APP_NAME} />
						</Link>
					</div>
					<div className="card forgot-pass">
						<div className="body">
							<p className="lead mb-3">{t('Nouveau mot de passe')}</p>
							{linkIsIncomplete ? (
								<>
									<p className="text-danger">{t('Ce lien est incomplet. Faites une nouvelle demande de réinitialisation.')}</p>
									<div className="bottom">
										<span className="helper-text"><Link to="/forgotpassword">{t('Demander un nouveau lien')}</Link></span>
									</div>
								</>
							) : (
								<form className="form-auth-small" onSubmit={formik.handleSubmit}>
									{alert && <AppAlert onClose={onClose} type={alert.type}>{alert.message}</AppAlert>}
									<p className="text-muted small">{t('Compte')} : {email}</p>
									<AppInput
										label={t("Nouveau mot de passe")}
										type="password"
										name="password"
										error={formik.errors.password}
										touched={formik.touched.password}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										value={formik.values.password}
										required
									/>
									<AppInput
										label={t("Confirmation du mot de passe")}
										type="password"
										name="password_confirmation"
										error={formik.errors.password_confirmation}
										touched={formik.touched.password_confirmation}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										value={formik.values.password_confirmation}
										required
									/>
									<button type="submit" disabled={submitting} className="btn btn-round btn-primary btn-lg btn-block font-weight-bold">
										{submitting ? t('Enregistrement...') : t('Enregistrer le mot de passe')}
									</button>
									<div className="bottom">
										<span className="helper-text">{t("Retour à la page de")} <Link to="/login">{t("connexion")}</Link></span>
									</div>
								</form>
							)}
						</div>
					</div>
				</div>
				<div id="particles-js"></div>
			</div>
		</>
	);
};

export default ResetPassword;
